import React, { useEffect } from "react";
import { Toast, ToastContainer, Button } from "react-bootstrap";

export default function AppToast({
  show,
  message,
  bg = "success",
  title,
  actionLabel,
  onAction,
  onClose,
}) {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(onClose, 5000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  const resolvedTitle =
    title ||
    (bg === "success"
      ? "Success"
      : bg === "warning"
      ? "Warning"
      : bg === "danger"
      ? "Error"
      : "Notice");

  return (
    <ToastContainer
      position="fixed"
      className="p-3 bottom-0 end-0"
      style={{ zIndex: 9999 }}
    >
      <Toast
        bg={bg}
        show={show}
        onClose={onClose}
        delay={5000}
        autohide
      >
        <Toast.Header>
          <strong className="me-auto">{resolvedTitle}</strong>
        </Toast.Header>

        <Toast.Body className="text-white">
          <div>{message}</div>
          {actionLabel && onAction ? (
            <div className="mt-2 d-flex justify-content-end">
              <Button
                size="sm"
                variant="light"
                onClick={() => {
                  onAction();
                  onClose();
                }}
              >
                {actionLabel}
              </Button>
            </div>
          ) : null}
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
}
